import {Col, Container, Form, Row} from "react-bootstrap";
import React, {useState} from "react";
import {Link} from 'react-router-dom';
import {HttpMethod} from '../../model';
import {httpClient} from '../../service';
import {getSessionVerify, VerifyConfigModel} from '../verifications/VerifyConfigModel';

export const Verification2Config = () => {
    const [validated, setValidated] = useState(false);
    const [model, setModel] = useState<VerifyConfigModel>(getSessionVerify);
    const [submitting, setSubmitting] = useState(false);

    const submitForm = async (e: any) => {
        const isValid = e.currentTarget.checkValidity();
        if (!isValid) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return false;
        }
        e.preventDefault();
        setSubmitting(true);

        const url = `test/verifications/2/config`;
        const options = {
            method: HttpMethod.POST,
            url,
            body: model
        }
        const act = await httpClient(options);
        setSubmitting(false);

        if (act.result) {
            if (act.data) {
                setModel(act.data);
                localStorage.setItem("verifyConfig", JSON.stringify(act.data));
                alert('성공적으로 설정되었습니다.');
            } else {
                alert('기본 환경설정 저장하는데 오류가 발생하였습니다.');
            }
        } else {
            alert(act.errorMsg);
        }


    };


    const handleInputChange = (e: any) => {
        console.log(`name=${e.target.name}, value=${e.target.value}`);
        const data = {...model, [e.target.name]: e.target.value};
        setModel(data);
    }
    const getShopName=()=>{
        let rval='';
        if(model.shopNm){
            rval=`검증1: ${model.shopNm}`;
        }
        if(model.shopNm4){
            rval+=`,검증4: ${model.shopNm4}`;
        }
        return rval;
    }
    return (
        <Container className="bloc-sm">
            <Row className="mb-1">
                <Col className="col-sm-6 text-left">
                    <Link to="/verification2" className="btn btn-sm btn-primary">Home</Link>
                </Col>
                <Col className="col-sm-6 text-right">
                    <h6 className="mg-md subtitle">검증 기본 환경설정</h6>
                </Col>
            </Row>
            <Row>
                <Col className="s12">
                    <Form id="form_539" data-form-type="blocs-form" noValidate validated={validated}
                          onSubmit={submitForm}>
                        <Form.Group>

                            <Form.Label
                                className="form-label">회원번호&nbsp;*</Form.Label>
                            <Form.Control name="custNo" required onChange={handleInputChange}
                                          defaultValue={model.custNo}
                            />
                            <Form.Control.Feedback type="invalid">
                                이 항목은 필수항목입니다.
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label
                                className="form-label">매장 ID(검증1)&nbsp;*</Form.Label>
                            <Form.Control name="shopId" required onChange={handleInputChange}
                                          defaultValue={model.shopId}
                            />
                            <Form.Control.Feedback type="invalid">
                                이 항목은 필수항목입니다.
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label
                                className="form-label">매장 ID(검증4)&nbsp;*</Form.Label>
                            <Form.Control name="shopId4" required onChange={handleInputChange}
                                          defaultValue={model.shopId4}
                            />
                            <Form.Control.Feedback type="invalid">
                                이 항목은 필수항목입니다.
                            </Form.Control.Feedback>
                        </Form.Group>
                            <Form.Group>
                                <Form.Label
                                    className="form-label">매장명</Form.Label>
                                <Form.Control name="shopNm" defaultValue={getShopName()} disabled={true}/>

                            </Form.Group>

                        <Form.Group>
                            <Form.Label
                                className="form-label">쿠폰ID(검증2적용, 최소5개입력)&nbsp;*</Form.Label>
                            <Form.Control name="couponIds" required onChange={handleInputChange}
                                          defaultValue={model.couponIds}
                            />
                            <Form.Control.Feedback type="invalid">
                                이 항목은 필수항목입니다.
                            </Form.Control.Feedback>
                        </Form.Group>
                        <button type="submit"
                                className="bloc-button btn btn-d btn-lg btn-block download-bt"
                                disabled={submitting}
                        >{submitting ? "설정중.." : "저장하기"}
                        </button>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}
